export const NOTIFICATION_LIST_INIT = 'NOTIFICATION_LIST_INIT'
export const NOTIFICATION_LIST_ADD = 'NOTIFICATION_LIST_ADD'
export const NOTIFICATION_LIST_REMOVE = 'NOTIFICATION_LIST_REMOVE'
export const NOTIFICATION_LIST_TIMEOUT_SAVE = 'NOTIFICATION_LIST_TIMEOUT_SAVE'
export const NOTIFICATION_LIST_ERROR = 'NOTIFICATION_LIST_ERROR'
export const NOTIFICATION_LIST_SINGLE_UPDATE = 'NOTIFICATION_LIST_SINGLE_UPDATE'
